import styled from 'styled-components';

// assets
import LoadingLogo from '../assets/images/loading-logo.gif';

// styles
// ----------------------------------------------------------------------

const Overlay = styled('div')`
  right: 0;
  bottom: 0;
  z-index: 99999;
  width: 100%;
  height: 100%;
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.02);
`;

const Image = styled('img')`
  width: 81px;
`;

// ----------------------------------------------------------------------

const LoadingScreen = () => {
  return (
    <Overlay>
      <Image src={LoadingLogo} alt="Loading..." />
    </Overlay>
  );
};
export default LoadingScreen;
